import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Inventory, InventorySchemaType } from '../../inventory.model';
import { InventorySchemaTypeHelper } from '../../../deployment-wizard/deployment-selection/inventory-list/inventory-schema-type.helper';
import { DeploymentRepository, KubernetesCluster, KubernetesInventoryContent } from '../../create-inventory/create-inventory-payload';
import _ from 'lodash';
import { InventoryParserHelper } from '../inventory-parser.helper';

@Component({
    selector: 'adm4-inventory-kubernetes-information',
    template: `
    <!-- TODO (paksyd): Re-enable displaying here the "Kubernetes Connection" section when the connect to Kubernetes modal dialog is implemented!-->
    @if (isKubernetesInventory) {
      <div class="section-title">Kubernetes Connection</div>
    }
    @if (isKubernetesInventory) {
      <table class='settings-info-table'>
        <tr>
          <td>
            @if (deploymentRepository && deploymentRepository.url) {
              <div class="key"> Deployment repository</div>
              {{ deploymentRepository.url }}
            }
          </td>
          <td>
            @if (deploymentRepository && deploymentRepository.branch) {
              <div class="key"> Branch</div>
              {{ deploymentRepository.branch }}
            }
          </td>
        </tr>
        <tr>
          <td>
            @if (kubernetesCluster && kubernetesCluster.url) {
              <div class="key"> Kubernetes cluster</div>
              {{ kubernetesCluster.url }}
            }
          </td>
          <td>
            @if (kubernetesCluster && kubernetesCluster.namespace) {
              <div class="key"> Namespace</div>
              {{ kubernetesCluster.namespace }}
            }
          </td>
        </tr>
      </table>
    }
    @if (!isKubernetesInventory) {
      <div class='inventory-actions'>
        <span><!-- Note: This empty span is needed so that the following button is layed out on the right side. --></span>
        <!-- TODO (paksyd): Re-enable here the "Deploy to Kubernetes" button when the connect to Kubernetes modal dialog is implemented!-->
        <!--
        <button type="button" class="admn4-button-ellipse-blue" (click)="openConnectInventoryToKubernetesDialog()">
          <span class="menu-item-text">Deploy to Kubernetes</span>
        </button>
        -->
      </div>
    }
    `,
    styleUrls: [
        '../inventory-information-common.scss',
        '../../../common/styles/component-specific/settings-info-table.scss'
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class InventoryKubernetesInformationComponent implements OnChanges {
  @Input() inventory: Inventory;
  @Input() inventoryContent?: string;
  @Input() inventorySchemaType?: InventorySchemaType;

  deploymentRepository: DeploymentRepository | null;
  kubernetesCluster: KubernetesCluster | null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['inventoryContent'] && this.isKubernetesInventory) {
      const inventoryContentParsed: KubernetesInventoryContent | null = InventoryParserHelper.parseInventoryContent(this.inventoryContent);
      if (!_.isNil(inventoryContentParsed)) {
        this.deploymentRepository = inventoryContentParsed['deployment-repository'];
        this.kubernetesCluster = inventoryContentParsed['kubernetes-cluster'];
      }
    }
  }

  get isKubernetesInventory(): boolean {
    return InventorySchemaTypeHelper.isKubernetesDeployment(this.inventorySchemaType);
  }

  openConnectInventoryToKubernetesDialog(): void {
    // TODO (paksyd): Implement opening Connect to Kubernetes modal dialog here!
  }
}
